import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../../consts/api";
import { uiNotification } from "../../../../../../../services/UINotificationService";

export const useDownloadSurchargeAgreement = (clinicId, options = {}) => {
  const res = useMutation(
    () =>
      http.get(HTTP_ENDPOINTS.customTax.downloadSurchargeAgreement(clinicId), {
        responseType: "blob",
      }),
    {
      onSuccess: (response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "Surcharge-Agreement.pdf";
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
      },
      onError: () =>
        uiNotification.error("Failed to download the surcharge agreement."),
      ...options,
    },
  );

  return res;
};
